module.exports = __webpack_public_path__ + "static/img/COC2023-23.86989b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-23.png
// module id = uayH
// module chunks = 0